import {
    CREATE_USER_MUTATION,
    UPDATE_USER_MUTATION
} from "../../../../store/entities/user-management/users/users.graphql";
import { Component, Inject, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DynamicFormService } from "../../../../shared/components/dynamic-forms-components/dynamic-form.service";
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { FieldConfig, FieldType } from "../../../../shared/components/dynamic-forms-components/field.interface";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../store";
import { StoreItemActions } from "../../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../../store/entities/store-item/store-item.model";
import { AccountTypesChoices, User, UserGenderChoices } from "../../../../store/entities/user-management/users/users.model";
import { UserTypeEnum } from "../../../../store/entities/uaa/auth-user.model";
import { GraphqlService } from "../../../../services/graphql.service";
import { SystemRolesAddComponent } from "../../system-roles-list/system-roles-add/system-roles-add.component";
import {ALL_REGIONS} from "../../../../store/entities/settings/administrative-area/region/region.graphql";
import {GET_ROLES_QUERY} from "../../../../store/entities/user-management/user-role/user-role.graphql";
import {isBase64} from "../../../../shared/helpers/functions.helper";
import {AttachmentService} from "../../../../services/attachment.service";

@Component({
    selector: 'app-user-add',
    templateUrl: './user-add.component.html',
    styleUrl: './user-add.component.scss'
})
export class UserAddComponent implements OnInit {

    private dynamicFormService: DynamicFormService = inject(DynamicFormService);
   

    title: string;
    loading: boolean = false
    form: UntypedFormGroup;
    saveLoading: boolean;
    fields: FieldConfig[] = this.formFields()
    user

    constructor(
        private fb: UntypedFormBuilder,
        private store: Store<AppState>,
        private apollo: GraphqlService,
        private dialogRef: MatDialogRef<UserAddComponent>,
        private attachmentService: AttachmentService,
        @Inject(MAT_DIALOG_DATA) public data,
    ) {
        this.user = data?.user
    }

    ngOnInit() {
        this.title = `${this.data?.user?.uniqueId ? "Edit " : "Add "} User`

        this.form = this.fb.group({
            firstName:['',Validators.required],
            lastName:['',Validators.required],
            email:['',Validators.required],
            phone:['',Validators.required],
            photo:[''],
            accountType:['',Validators.required],
            roleUniqueId:['',Validators.required],

        })

        if (this.data?.user?.uniqueId) {
            this.form.patchValue({
                firstName:this.data?.user?.firstName,
                lastName:this.data?.user?.lastName,
                gender:this.data?.user?.gender,
                email:this.data?.user?.email,
                phone:this.data?.user?.phone,
                title:this.data?.user?.title,
                accountType:this.data?.user?.accountType,
                roleUniqueId:this.data?.user?.role?.uniqueId,
            })
        }
    }


    submitForm(formValue) {
        this.loading = true;

        const input = !this.data?.user?.id ? {...formValue} : {
            ...formValue,
            uniqueId: this.data?.user?.uniqueId,
            accountType: this.getKeyFromValue(formValue?.accountType),
        };

        let _b64 = formValue?.photo?.base64?.split(',')[1];

        const doDispatch = (finalInput) => {
            const mutation = this.data?.user?.id ? UPDATE_USER_MUTATION : CREATE_USER_MUTATION;

            this.store.dispatch(StoreItemActions.createUpdateStoreItem({
                entity: StoreItemEntity.user,
                input: finalInput,
                mutation: mutation,
                isInput: true,
            }));

            setTimeout(() => {
                this.dialogRef.close({
                    success: true,
                    updatedUser: {
                        ...finalInput,
                        firstName: formValue.firstName,
                        lastName: formValue.lastName,
                        email: formValue.email,
                        phone: formValue.phone,
                        accountType: formValue.accountType,
                        role: { roleName: '' } 
                    }
                });
            }, 500);
        }

        if (!isBase64(_b64)) {
            doDispatch(input);
            return;
        }

        this.attachmentService.saveAttachment(_b64, formValue?.firstName).then(x => {
            input.photo = x.filePath;
            doDispatch(input);
        });
    }

    formFields(): FieldConfig[] {
        return [

            {
                type: FieldType.input,
                label: 'First Name',
                key: 'firstName',
                validations: [
                    {
                        message: 'Field is required',
                        validator: Validators.required,
                        name: 'required',
                    },
                ],
                rowClass: 'col-span-6',
            },
            {
                type: FieldType.input,
                label: 'Last Name',
                key: 'lastName',
                validations: [
                    {
                        message: 'Field is required',
                        validator: Validators.required,
                        name: 'required',
                    },
                ],
                rowClass: 'col-span-6',
            },
            {
                type: FieldType.input,
                label: 'Email',
                key: 'email',
                validations: [
                    {
                        message: 'Invalid email address',
                        validator: Validators.email,
                        name: 'email',
                    },
                    {
                        message: 'Field is required',
                        validator: Validators.required,
                        name: 'required',
                    },
                ],
                rowClass: 'col-span-4',
            },
            {
                type: FieldType.select,
                label: 'Account Type',
                key: 'accountType',
                options: Object.keys(AccountTypesChoices).map((key) => {
                    return {
                        "name": key,
                        "value": key,
                    };
                }),
                rowClass: 'col-span-4',
            },
            // {
            //     type: FieldType.select,
            //     label: 'Gender',
            //     key: 'gender',
            //
            //     validations: [
            //         {
            //             message: 'Field is required',
            //             validator: Validators.required,
            //             name: 'required',
            //         },
            //     ],
            //     options: Object.keys(UserGenderChoices).map((key) => {
            //         return {
            //             "name": key,
            //             "value": key,
            //         };
            //     }),
            //     rowClass: 'col-span-4',
            // },
            // {
            //     type: FieldType.input,
            //     label: 'Title',
            //     key: 'title',
            //     validations: [
            //         {
            //             message: 'Field is required',
            //             validator: Validators.required,
            //             name: 'required',
            //         },
            //     ],
            //     rowClass: 'col-span-6',
            // },
            {
                type: FieldType.input,
                label: 'Phone',
                key: 'phone',
                validations: [
                    {
                        message: 'Field is required',
                        validator: Validators.required,
                        name: 'required',
                    },
                ],
                rowClass: 'col-span-4',
            },
            {
                type: FieldType.paginatedselect,
                label: 'Role',
                key: 'roleUniqueId',
                query: GET_ROLES_QUERY,
                optionName: 'roleName',
                optionValue: 'uniqueId',
                showOtherOption: false,
                validations: [
                    {
                        message: 'Field is required',
                        validator: Validators.required,
                        name: 'required',
                    },
                ],
                rowClass: 'col-span-12',
            },
            {
                type: FieldType.attachment,
                label: 'Photo',
                key: 'photo',
                acceptType: ['.png', '.jpg', '.jpeg'],
                rowClass: 'col-span-12',
            },
            {
                type: FieldType.button,
                label: 'Save',
                rowClass: 'col-span-12',
            },
        ];
    }
    getKeyFromValue = (value: string): string | undefined => {
        const key = Object.keys(AccountTypesChoices).find(key => AccountTypesChoices[key as keyof typeof AccountTypesChoices] === value);
        return key;
    }
    closeModal() {
        this.dialogRef.close()
    }
}
